var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 146,
    viewBox: "0 0 150 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.525154,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M147.531 112.406C148.253 120.659 126.042 129.342 97.9225 131.803C69.8016 134.263 46.4201 129.568 45.698 121.315C44.9759 113.062 67.1869 104.377 95.3078 101.917C123.428 99.4566 146.809 104.152 147.531 112.406Z",
    fill: "#C7B299"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0919 127.092C87.966 135.097 118.673 117.368 126.678 87.4939C134.682 57.6198 116.954 26.9129 87.0796 18.9082C57.2055 10.9034 26.4987 28.6321 18.4939 58.5062C10.4892 88.3803 28.2178 119.087 58.0919 127.092Z",
    fill: "#6F41D8",
    stroke: "white",
    strokeWidth: 6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1235 71.2137L66.4875 82.2364",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M87.895 64.1612L66.4403 82.2636",
    stroke: "white",
    strokeWidth: 7,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.90ea2740.svg";
export { ForwardRef as ReactComponent };